import { CardFlagsTypes } from '@/domain/models'

export const getCreditCardType = (creditCardNumber: string): CardFlagsTypes => {
  let result: CardFlagsTypes | 'unknown' = 'unknown'

  if (/^5[1-5]/.test(creditCardNumber)) {
    result = 'mastercard'
  } else if (/^4/.test(creditCardNumber)) {
    result = 'visa'
  } else if (/^3[47]/.test(creditCardNumber)) {
    result = 'amex'
  } else if (/3(?:0[0-5]|[68][0-9])[0-9]{11}/.test(creditCardNumber)) {
    result = 'diners'
  } else if (/6(?:011|5[0-9]{2})[0-9]{12}/.test(creditCardNumber)) {
    result = 'discover'
  }

  return result
}
